export enum FeedbackPageType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum FeedbackPageFlow {
  EDIT_ALIAS = 'EDIT_ALIAS',
  BANK_NOTE_WORLD_CUP_SEARCH = 'BANK_NOTE_WORLD_CUP_SEARCH',
}

export type FeedbackPageContent = {
  title: string
  primaryButton: string
}

export type FeedbackPageData = Record<
  string,
  { [flow in FeedbackPageFlow]?: { [type in FeedbackPageType]?: FeedbackPageContent } }
>

export type FeedbackReturnType = 'redirect' | 'deeplink' | 'goback'

export const feedbackRoutes: Record<FeedbackPageFlow, { type: FeedbackReturnType; route: string }> =
  {
    [FeedbackPageFlow.EDIT_ALIAS]: { type: 'redirect', route: '/account-info' },
    [FeedbackPageFlow.BANK_NOTE_WORLD_CUP_SEARCH]: {
      type: 'goback',
      route: '',
    },
  }
